import type { Ref } from 'vue';
import { onMounted, onUnmounted, ref } from 'vue';

export type MetricTarget = {
  count: number;
  suffix: string;
  unit?: string;
  label: string;
  delayClass?: string;
};

/** 指标数字滚动动画 */
export function useCountUp(rootRef: Ref<HTMLElement | null>, targets: MetricTarget[]) {
  const display = ref(targets.map(() => '0'));
  let observer: IntersectionObserver | null = null;

  function animate(index: number) {
    const { count, suffix } = targets[index];
    const duration = 1800;
    const start = performance.now();
    const easeOut = (t: number) => 1 - Math.pow(1 - t, 3);
    const tick = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      display.value[index] = String(Math.round(easeOut(progress) * count)) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  onMounted(() => {
    const root = rootRef.value;
    if (!root) return;
    const items = root.querySelectorAll('.metric-item');
    const counted = new Set<number>();
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = Array.from(items).indexOf(entry.target as Element);
          if (idx < 0 || counted.has(idx)) return;
          counted.add(idx);
          animate(idx);
        });
      },
      { threshold: 0.3 }
    );
    items.forEach((el) => observer!.observe(el));
  });

  onUnmounted(() => {
    observer?.disconnect();
  });

  return { display };
}
